import useSWR from 'swr';
import { SiteSettings } from '@/lib/api';

// Хук для получения настроек сайта
export function useSiteSettings() {
  const { data, error, isLoading, isValidating, mutate } = useSWR<SiteSettings>(
    '/api/settings/',
    {
      // Настройки редко меняются — обновляем раз в 5 минут в фоне
      refreshInterval: 300000,
      // Не блокируем UI при ревалидации
      revalidateIfStale: true,
    }
  );

  return {
    settings: data ?? null,
    isLoading,
    isValidating,
    error,
    mutate,
  };
}
